import { ProductStatus, ProjectDto } from 'api';
import styles from './Projects.module.less';
import defaultLandscapePicture from 'assets/img/default-landscape.svg';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image } from 'antd';
import { TProductStatus } from 'utils/productUtils';

type Props = {
	project: ProjectDto;
};

export default function ProjectTile(props: Props) {
	const { project } = props;
	const { t } = useTranslation();

	return (
		<div
			data-testid={`project_tile_${project.id}`}
			className={styles.projectTile}
		>
			<Link to={`/project/${project.id}`}>
				<Image
					data-testid={`project_tile_image_${project.id}`}
					width="40vw"
					className={styles.tileImage}
					src={project.heroImage || defaultLandscapePicture}
					fallback={defaultLandscapePicture}
					preview={false}
				/>
				<div className={styles.tileBox}>
					<div className={styles.tileBoxContent}>
						<h2
							data-testid={`project_tile_title_${project.id}`}
							className={styles.tileTitle}
						>
							{project.name}
						</h2>
						<h3
							data-testid={`project_tile_description_${project.id}`}
							className={styles.tileDescription}
						>
							{t(TProductStatus[project.status as ProductStatus])}
						</h3>
						<h3
							data-testid={`project_tile_created_date_${project.id}`}
							className={styles.tileDescription}
						>
							{`${t('ProjectPage.Created')} ${moment(
								project.createdDate,
							).format('MMMM D, Y')}`}
						</h3>
					</div>
				</div>
			</Link>
		</div>
	);
}
